import {
  getAdditionEntityName,
  IAdditionEntity,
  IDropdownItem,
} from "@ryde/shared";

import { IPassengerTier, IPricingReasonDto } from "./passenger-addition.models";

export const sortPassengerTiers = (tiers: IPassengerTier[]): IPassengerTier[] =>
  [...tiers].sort((a, b) => a.from - b.from);

export const mapPricesToAdditionsByReasons = (
  prices: IPricingReasonDto[],
  reasons: IDropdownItem[],
): IAdditionEntity[] => {
  const result = (prices || []).flatMap(priceDto => {
    const ids: number[] = priceDto?.reasonIds || [];
    return ids.map((reasonId: number) => ({
      id: reasonId,
      price: priceDto.price,
      name: getAdditionEntityName(reasonId, reasons),
    }));
  });

  return result as IAdditionEntity[];
};

export const mapEntityPricesToReasonDto = (
  prices: IAdditionEntity[],
): IPricingReasonDto[] => {
  const byPrice = new Map<number, IPricingReasonDto>();

  for (const entity of prices || []) {
    const key = entity.price;
    const dto = byPrice.get(key);
    if (dto) {
      dto.reasonIds.push(entity.id);
    } else {
      byPrice.set(key, { price: key, reasonIds: [entity.id] });
    }
  }

  return Array.from(byPrice.values());
};
